// localStorage polyfill
let localStorage = window.localStorage;

if (!localStorage) {
  let data = {};

  localStorage = {
    setItem(id, val) {
      return data[id] = String(val);
    },
    getItem(id) {
      return Object.prototype.hasOwnProperty.call(data, id) ? data[id] : undefined;
    },
    removeItem(id) {
      return delete data[id];
    },
    clear() {
      return data = {};
    },
  };
}

export default localStorage;
